"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleDropOffMessageDto = void 0;
const VehicleDropOffDto_1 = require("../vehicle-drop-offs/VehicleDropOffDto");
class VehicleDropOffMessageDto {
    constructor(params) {
        if (!params) {
            return;
        }
        this.id = params.id;
        this.vehicleDropOffId = params.vehicleDropOffId;
        this.messageType = params.messageType;
        this.text = params.text;
        this.imageFileName = params.imageFileName;
        this.imageContentType = params.imageContentType;
        this.imageFileSize = params.imageFileSize;
        this.imageUpdatedAt = params.imageUpdatedAt;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.from = params.from;
        this.attachmentFileName = params.attachmentFileName;
        this.attachmentContentType = params.attachmentContentType;
        this.attachmentFileSize = params.attachmentFileSize;
        this.attachmentUpdatedAt = params.attachmentUpdatedAt;
        this.paymentInvoiceUrl = params.paymentInvoiceUrl;
        this.paymentAmount = params.paymentAmount;
        this.paymentRequestStatus = params.paymentRequestStatus;
        if (params.vehicleDropOff !== undefined) {
            this.vehicleDropOff = params.vehicleDropOff ?
                new VehicleDropOffDto_1.VehicleDropOffDto(params.vehicleDropOff) :
                null;
        }
    }
}
exports.VehicleDropOffMessageDto = VehicleDropOffMessageDto;
//# sourceMappingURL=VehicleDropOffMessageDto.js.map